import { AideAudienceStubPage } from '../../../../components/aides/AideAudienceStubPage';
import { AIDES_PROFESSIONNELS } from '../../../../config/aides-professionnels';

export default function SuramortissementPage() {
  const aide = AIDES_PROFESSIONNELS.find((a) => a.slug === 'suramortissement');
  if (!aide) return null;
  return <AideAudienceStubPage aide={aide} audienceId="professionnels" />;
}
